import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from './ApiService';

@Injectable({
  providedIn: 'root'
})
export class MultiApiService {

  baseUrl:string = environment.taxpayer_base_url;

  submissionIncludingDacon = '/filingservice/v3/api/get-submission-including-dacon';
  getSubmission = "/filingservice/v3/api/get_submission";

  constructor(private apiService: ApiService) { }

  getSubmissionIncludingDacon(){
    return this.apiService.get(this.baseUrl + this.submissionIncludingDacon)
  }

  getSubmissionInfo(){
    return this.apiService.get(this.baseUrl + this.getSubmission)
  }
}
